import { render, staticRenderFns } from "./addColumn.vue?vue&type=template&id=c826c644&scoped=true&"
import script from "./addColumn.vue?vue&type=script&lang=js&"
export * from "./addColumn.vue?vue&type=script&lang=js&"
import style0 from "./addColumn.vue?vue&type=style&index=0&id=c826c644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c826c644",
  null
  
)

export default component.exports